import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-beta',
  templateUrl: './icon-beta.component.html',
  styleUrl: './icon-beta.component.scss',
  standalone: false
})
export class IconBetaComponent {
  @Input() tooltip?: string;
}
